module.exports = __webpack_public_path__ + "img/no hay articulos.341cdbb0.png";